import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { upperFirst } from 'lodash-es';

import { ISitemateTaskDefinitionWarning } from '@site-mate/dashpivot-shared-library';

import { TmpI18NService } from 'app/i18n/tmp-i18n.service';

type ISitemateTaskDefinitionTranslatedWarning = ISitemateTaskDefinitionWarning & { description: string };

@Component({
  selector: 'cc-template-links-modal-completed-with-warnings',
  templateUrl: './template-links-modal-completed-with-warnings.component.html',
  styleUrls: [
    '../../templates-library/templates-selector/templates-selector-common.scss',
    './template-links-modal-completed-with-warnings.component.scss',
  ],
})
export class TemplateLinksModalCompletedWithWarningsComponent implements OnInit {
  @Input() warnings: ISitemateTaskDefinitionWarning[];
  @Input() taskCreationMode: string;
  @Output() readonly acknowledge = new EventEmitter<void>();
  @Output() readonly closeModal = new EventEmitter<void>();

  localWarnings: ISitemateTaskDefinitionTranslatedWarning[];

  constructor(private readonly i18nService: TmpI18NService) {}

  ngOnInit(): void {
    this.localWarnings = this.warnings.map(this.translateWarning.bind(this));
  }

  onAcknowledge(): void {
    this.acknowledge.emit();
  }

  onCloseModal(): void {
    this.closeModal.emit();
  }

  private translateWarning(
    rawWarning: ISitemateTaskDefinitionWarning,
  ): ISitemateTaskDefinitionTranslatedWarning {
    return {
      templateName: rawWarning.templateName,
      description: this.i18nService.getMessage(`templateLink${upperFirst(rawWarning.description)}`) as
        | 'isWorkflow'
        | 'hasSignOnField',
    };
  }
}
